var style = {"z-flatbox":"z-flatbox","z-brand-theme-zooplus":"z-brand-theme-zooplus","z-brand-theme-bitiba":"z-brand-theme-bitiba","z-flatbox--rounded":"z-flatbox--rounded","z-flatbox--white":"z-flatbox--white"};

export { style as default };
//# sourceMappingURL=FlatBox.module.scss.js.map
